
/* Successive Vice Chancellors of Rayalaseema University */
export const vcsList = [
  {
    id: 1,
    name: "Prof. Jujjuri Venkata Prabhakara Rao",
    period: "28-07-2008 to 27-07-2011",
    image: "/VCs/vc1.jpg",
  },
  {
    id: 2,
    name: "Prof. Khatravath Krishna Naik",
    period: "22-10-2011 to 09-11-2014",
    image: "/VCs/vc2.jpg",
  },
  {
    id: 3,
    name: "Prof. Y. Narasimhulu",
    period: "15-04-2015 to 05-04-2018",
    image: "/VCs/vc3.jpg",
  },
  {
    id: 4,
    name: "Prof. A. V. PRASADA RAO",
    period: "06-08-2018 to 11-12-2019",
    image: "/VCs/vc4.jpg",
  },
  
  
  {
    id: 6,
    name: "Prof. A. Anada Rao",
    period: "27-11-2020 to 24-11-2023",
    image: "/VCs/vc6.jpg",
  },
  {
    id: 7,
    name: "Prof. B. Sudheer Prem Kumar",
    period: "17-01-2024 to 18-07-2024",
    image: "/VCs/vc7.jpg",
  },
  {
    id: 9,
    name: "Prof. V. Venkata Basava Rao",
    period: "18-02-2025 to Till Date",
    image: "/person/vicechancellor2.JPG",
  },
];

/* In-charge Vice Chancellors */
export const inchargeVCsList = [
 
  {
    id: 1,
    name: "Sri Mudavatu. M. Nayak, IAS.",
    period: "",
    image: "/VCs/vc5.png",
  },
   {
    id: 2,
    name: "Prof. N. T. K. Naik",
    period: "18-07-2024 to 18-02-2025",
    image: "/person/ntk-old.jpeg",
  }
  
];
